<template>
  <div style="flex: 1;" class="mt-3">
    <div style="display: grid;" class="mx-2">
      <div v-if="convo && owner" style="grid-area: 1/1/1/1; justify-self: start;
      display: flex;align-items: center;flex-wrap: wrap; gap: 8px;">
  <!-- Back icon -->
        <v-icon
          v-if="(convo && _process === 'Lab Conversation') || (convo && isMobile)"
          size="small"
          style="cursor: pointer; margin-right: 6px;"
          @click="handleBack"
        >
          mdi-arrow-left
        </v-icon>

  <!-- Owner info -->
      <div style="display: flex; flex-direction: column; align-items: center;">
        <UserPopup :user_id="owner" :dense="true" />
        <div class="text-caption" style="color: #757575; display: flex; align-items:center; justify-content: center;">
          <v-icon size="small">mdi-account</v-icon>
          Owner
        </div>
      </div>
    <!-- Tag select next to Owner -->
    <div
      v-if="($route.path === '/conversation' || $route.path === '/osclaims') && convo"
      style="display: flex; align-items: center; width:100px;"
    >
    <v-select
      :items="tagfilter"
      item-title="tag_name"
      item-value="tag_id"
      v-model="selectedTag"
      label="Tag"
      placeholder ="Tag"
      variant="outlined"
      density="compact"
      hide-details
      style="max-width: 160px;"
    >
      <template v-slot:append-inner>
        <v-icon
          v-if="selectedTag"
          @click.stop="clearselectedtag"
          class="ml-1"
        >
          mdi-close
        </v-icon>
      </template>
    </v-select>
    </div>
  <!-- Outstanding claim details -->
      <template v-if="_process === 'outstanding claim'">
<v-menu offset-y :close-on-content-click="false" width="300">
    <template v-slot:activator="{ props }">
      <v-btn v-bind="props" variant="text" size="small" class="text-capitalize">
       <strong> O/S details </strong>
        <v-icon right small>mdi-chevron-down</v-icon>
      </v-btn>
    </template>
     <v-card width="300">
      <v-list dense class="pa-2">
      <v-list-item class="py-1">
        <v-row class="w-100" align="center" dense>
          <!-- Carrier -->
          <v-col cols="4" class="py-0">
            <div class="font-weight-bold text-blue text-caption">
              {{ matchedClaim?.Carrier || 'N/A' }}
            </div></v-col>
          <!-- Phone -->
          <v-col cols="4" class="py-0">
            <v-tooltip location="top" :text="phoneFormat(matchedClaim?.PhNum) || 'N/A'">
              <template #activator="{ props }">
                <v-btn v-bind="props"variant="tonal"color="green"size="x-small"class="pa-1"
                  @click="phoneCall(matchedClaim.Carrier, matchedClaim.PhNum)"
                >
                  <v-icon small>mdi-phone</v-icon>
                </v-btn>
               </template>
            </v-tooltip>
          </v-col>
          <!-- Amount -->
          <v-col cols="4" class="py-0 text-right">
            <div class="text-caption">
              {{ matchedClaim?.Amount ? '$' + matchedClaim.Amount : 'N/A' }}
            </div></v-col>
        </v-row>
      </v-list-item>
      <!-- Date of Service -->
      <v-list-item class="py-1">
        <div class="d-flex justify-space-between w-100 text-caption">
          <span class="font-weight-bold">Date:</span>
          <span>{{ simpleDateFormat(matchedClaim?.DOS) || 'N/A' }}</span>
        </div></v-list-item>
      <!-- Procedures -->
      <v-list-item class="py-1">
        <div class="d-flex justify-space-between w-100 text-caption">
          <span class="font-weight-bold">Procedures:</span>
          <span>{{ matchedClaim?.Procedures || 'N/A' }}</span>
        </div> </v-list-item>
       </v-list>
  </v-card>
</v-menu>

        <!-- Applied OSClaims convo-level tag chips -->
        <template v-for="oct in appliedOsclaimsTags" :key="oct.tag_id">
          <v-tooltip :text="oct.tag?.tag_name || tagsHashnew[oct.tag_id]?.tag_name" location="bottom">
            <template #activator="{ props }">
              <v-btn
                v-bind="props"
                icon
                size="25"
                color="white"
                elevation="2"
                style="margin-top: 2px;"
                @click="removeOsclaimsTag(oct.tag_id)"
              >
                <v-icon
                  size="16"
                  :color="oct.tag?.tag_color || tagsHashnew[oct.tag_id]?.tag_color"
                >
                  mdi-{{ oct.tag?.tag_icon || tagsHashnew[oct.tag_id]?.tag_icon }}
                </v-icon>
              </v-btn>
            </template>
          </v-tooltip>
        </template>

        <!-- Add tag button -->
        <v-btn icon variant="text" size="small" @click="showOsclaimsTagPopup = true">
          <v-icon size="18" color="red">mdi-tag-plus</v-icon>
          <v-tooltip activator="parent" location="top">Apply Tag</v-tooltip>
        </v-btn>

  

        <!-- Tag picker popup -->
        <div class="shared-overlay" v-if="showOsclaimsTagPopup">
          <TagPopup
            v-model="showOsclaimsTagPopup"
            :tags="availableOsclaimsConvoTags"
            @applyTag="addOsclaimsTag"
            :isTagpopup="true"
            :enableEdit="false"
          />
                <!-- Open tag settings button -->
        <v-btn icon variant="text" size="small" @click="openOsclaimsTagSettings">
          <v-icon size="18" color="grey-darken-1">mdi-tag-edit-outline</v-icon>
          <v-tooltip activator="parent" location="top">Manage Tags</v-tooltip>
        </v-btn>
        </div>
</template>
      </div>
      <div 
  v-if="isMobile && convo"
  style="grid-area: 1/1/1/1; justify-self: center; align-self: center;" 
  class="mx-2"
>
  <div class="text-caption" style="text-align: center;">Process: {{ this._process }}</div>
<v-menu
  v-if="convo?.convo_status && (convo?.owner === userId || convo?.convo_participants.some((p) => p.user_id === userId) ||isAdmin)"
  offset-y
  max-width="300"
  offset-overflow
>
  <template v-slot:activator="{ props }">
    <v-icon v-bind="props" size="small" class="ml-1">mdi-menu-down</v-icon>
  </template>
  <v-card>
 <div v-if="owner === userId || isAdmin">
  <!-- Admin AND Owner see these -->
  <v-btn small text @click="$emit('updateConvoStatus', false)">Close Conversation</v-btn>

  <v-btn v-if="owner === userId" small text>Transfer Conversation Ownership</v-btn>
</div>
<div v-else-if="convo?.convo_participants.some(p => p.user_id === userId)">
  <!-- Only participants see Leave -->
  <v-btn small text @click="$emit('leaveConversation')">Leave Conversation</v-btn>
</div>
  </v-card>
</v-menu>
  <div
    v-if="mentionedUsers.length"
    style="display: flex; flex-wrap: wrap; justify-content: center; align-items: center"
  >
    <div style="color: #757575;" class="text-caption mr-1">
      Uncompleted Tasks:
    </div>
    <div v-for="user_id in mentionedUsers" :key="user_id" style="margin-right: -6px;">
      <UserPopup :user_id="user_id" :dense="true" />
    </div>
  </div>
  <div v-if="!convo.convo_status" class="mt-1 text-center">
    <v-btn size="small" color="primary" @click="$emit('updateConvoStatus', true)">Reopen Conversation</v-btn>
  </div>
</div>
      <div v-if="!isMobile && convo" style="grid-area: 1/1/1/1; justify-self: center; align-self: center;" class="mx-2">
        Process: {{ this._process }}
        <div class="text-h6" style="display: flex; align-items:center;">
          <div style="flex: 1 1 1">{{ header }}</div>
            <v-menu
            v-if="
              convo &&
                convo?.convo_status &&
                (convo?.owner === userId || convo?.convo_participants.some((p) => p.user_id === userId) ||isAdmin) 
                && _process != 'Lab Conversation'
            "
            offset-y
            max-width="300"
            offset-overflow
            style="flex: 1 1 1"
          >
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" size="small">mdi-menu-down</v-icon>
            </template>
            <v-card>
              <div v-if="owner === userId || isAdmin" style="display: flex; flex-direction: column">
                <v-btn style="flex: 1 1 1;" small text @click="$emit('updateConvoStatus', false)">
                  Close Conversation
                </v-btn>
                <v-btn v-if="owner === userId" style="flex: 1 1 1;" small text>Transfer Conversation Ownership</v-btn>
              </div>
              <div v-else-if="convo?.convo_participants.some(p => p.user_id === userId)" style="display: flex; flex-direction: column">
                <v-btn style="flex: 1 1 1;" small text @click="$emit('leaveConversation')">
                  Leave Conversation
                </v-btn>
              </div>
            </v-card>
          </v-menu>
        </div>
        <div
          v-if="convo && mentionedUsers.length"
          style="display: flex; flex-wrap: nowrap; justify-content: center; align-items: center"
        >
          <div style="color: #757575;" class="text-caption mr-1">
            Uncompleted Tasks:
          </div>
          <div v-for="user_id in mentionedUsers" :key="user_id" style="flex: 1 1 1; margin-right: -6px;">
            <UserPopup :user_id="user_id" :dense="true" />
          </div>
        </div>
        <div v-if="convo && !convo.convo_status" class="mt-1">
          <v-btn size="small" color="primary" @click="$emit('updateConvoStatus', true)">Reopen Conversation</v-btn>
        </div>
      </div>
      <div
        v-if="convo && convo?.convo_participants && convo?.convo_participants.length"
        style="grid-area: 1/1/1/1; justify-self: end;"
      >
        <div
          style="display: flex; flex-direction: row-reverse; flex-wrap: nowrap; justify-content: end; align-items: center;"
        >
          <div
            v-for="user in convo?.convo_participants"
            :key="user.user_id"
            style="flex: 1 1 1;"
            :class="{'margin-left' :  convo?.convo_participants.length >= 2}"
          >
            <UserPopup :user_id="user.user_id" :badge="getReminder(user.user_id) ? true : false" :dense="true">
              <template v-slot:badge>
                <v-tooltip location="top" :text="dayjs(getReminder(user.user_id).reminder_date).format('h:mmA M/D/YYYY')">
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props">mdi-alarm</v-icon>
                  </template>
                </v-tooltip>
              </template>
            </UserPopup>
          </div>
        </div>
        <div class="text-caption" style="color: #757575; display: flex; align-items:center; justify-content: center;">
          <v-icon size="small">mdi-account-multiple</v-icon>
          Participants
        </div>
        </div>
    </div>
    <v-divider class="mt-1"></v-divider>
  </div>
</template>

<script>
import UserPopup from "@/components/Avatar/UserPopup";
import TagPopup from "../CustomPopup.vue";
import { mapGetters , mapMutations } from "vuex";
import { phoneFormat } from "../../util/util";
import EventBus from "@/eventBus";
import dayjsMixin from "../../mixins/dayjsMixin";
import tagService from "@/services/tagService";
export default {
  name: "MessengerHeader",  
  mixins: [dayjsMixin],
  components: {
    UserPopup,
    TagPopup,
  },
  data() {
  return {
    matchedClaim: null,
    showDetails: false,
    selectedTag: null,
    showOsclaimsTagPopup: false,
    appliedOsclaimsTags: [],
  }
},
  props: {
    convo: { type: Object, default: null },
    header: { type: String, default: "" },
    owner: { type: Number, default: null},
  },
  computed: {
        ...mapGetters(['isAdmin']),
    ...mapGetters(["userId"]),
    ...mapGetters("osclaims",["_process","claims"]),
    ...mapGetters("window", ["isMobile"]),
    ...mapGetters("tags",["convoTags","osclaimsTags","osclaimsConvoTags","tagsHashnew"]),
    // removes the duplicated from the mentions for users that have been mentioned more than once
    mentionedUsers: function() {
      return [...new Set(this.convo?.convo_mentions.map((m) => m.user_id))];
    },
    isOSClaims() {
      return this.$route.path === '/osclaims' ? true : false;
    },
tagfilter() {
    const sourceTags = this.$route.path === '/osclaims'
      ? this.osclaimsTags
      : this.convoTags;
    return sourceTags.filter(tag =>
      !tag.tag_Process || tag.tag_Process === this._process || tag.tag_Process === "All"
    );
  },

  availableOsclaimsConvoTags() {
    const appliedIds = new Set(this.appliedOsclaimsTags.map(t => t.tag_id));
    return this.osclaimsConvoTags.filter(tag => !appliedIds.has(tag.tag_id));
  },

  },
    watch: {
    convo: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.matchedClaim = null;
          this.appliedOsclaimsTags = newVal.osclaims_conversation_tags || [];
          this.checkdata(newVal);
        }
      }
  },
    selectedTag: {
      immediate: true,
    handler(newVal) {
    if (newVal) this.onTagSelected(newVal);
      }
    }
  },
   methods: {
  ...mapMutations("osclaims", ["changeProcess"]),
    handleBack() {
    if (this._process === "Lab Conversation") {
      this.closeLab();
       EventBus.$emit("back-to-FDLeft");
    } else {
      this.goBack();
    }
  },
  onTagSelected(tagId) {
    console.log("Selected tag:",tagId );
    EventBus.$emit("ConversationTagFilter",tagId);
  },
  clearselectedtag() {
  this.selectedTag = null;
  console.log("Selected tag is cleared");
  EventBus.$emit("ConversationTagFilter", null);
},
    closeLab() {
      EventBus.$emit("openlab_conversation", false);
      EventBus.$emit("showRightPanel", true);
      this.changeProcess(" ");
    },
    checkdata(data) {
       if (this._process === "Lab Conversation") return;
      if (!data) return;
      const claim = this.claims.find(c => c.convo_id === data.convo_id);
      this.matchedClaim = claim ? {...claim} : null;
      if (!this.matchedClaim) {
        console.warn('No matching claim found for convo_id:', data.convo_id);
      }
    },
   
      phoneCall(name, number) {
      console.log("this call to the lab num and name ", name, number);
      this.carrierSelected = name;
      EventBus.$emit("call-event", { name, number });
    },
      phoneFormat,
    // gets the reminder for the convo based on the participant provided
    getReminder(participant_id) {
      if (!this.convo || !this.convo.convo_reminders?.length) return false;
      let r = this.convo.convo_reminders.find((r) => r.reminder_for_who === participant_id);
      return r ? r : false;
    },
    goBack(){
      EventBus.$emit("back-to-convoLeft");
    },

    openOsclaimsTagSettings() {
      EventBus.$emit("Open-Tag-Settings", { tagSource: "OSclaimsconvoTags" });
    },

    async addOsclaimsTag(tag_id) {
      if (!this.convo?.convo_id) return;
      try {
        await tagService.addOsclaimsTag({ convo_id: this.convo.convo_id, tag_id });
        const tagDetail = this.tagsHashnew[tag_id];
        if (tagDetail && !this.appliedOsclaimsTags.some(t => t.tag_id === tag_id)) {
          this.appliedOsclaimsTags.push({ tag_id, tag: tagDetail });
        }
      } catch (e) {
        console.error("Failed to add OSClaims tag", e);
      } finally {
        this.showOsclaimsTagPopup = false;
      }
    },

    async removeOsclaimsTag(tag_id) {
      if (!this.convo?.convo_id) return;
      try {
        await tagService.removeOsclaimsTag(this.convo.convo_id, tag_id);
        this.appliedOsclaimsTags = this.appliedOsclaimsTags.filter(t => t.tag_id !== tag_id);
      } catch (e) {
        console.error("Failed to remove OSClaims tag", e);
      }
    },
  },
   mounted() {
    EventBus.$on("closetagfilter", () => {
      this.clearselectedtag();
    });

    EventBus.$on("addTagsToOsClaims", ({ convo_id, tag_id }) => {
      if (this.convo?.convo_id !== convo_id) return;
      if (!this.appliedOsclaimsTags.some(t => t.tag_id === tag_id)) {
        this.appliedOsclaimsTags.push({ tag_id, tag: this.tagsHashnew[tag_id] || null });
      }
    });

    EventBus.$on("removeTagForOsClaims", ({ convo_id, tag_id }) => {
      if (this.convo?.convo_id !== convo_id) return;
      this.appliedOsclaimsTags = this.appliedOsclaimsTags.filter(t => t.tag_id !== tag_id);
    });
  },
   beforeUnmount() {
    EventBus.$off("closetagfilter");
    EventBus.$off("addTagsToOsClaims");
    EventBus.$off("removeTagForOsClaims");
   }
  };
</script>
<style scoped>
.margin-left{
  margin-left: -8px;
}
</style>
